(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apps"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('riven-forms-status')) {
 customElements.define('riven-forms-status',class extends HTMLElement {
  connectedCallback() {
   this.started = Date.now();
   this.check = () => {
    const root = this.querySelector('[data-form-root]');
    const hasFields = (node) => {
     if (!node) return false;
     if (node.shadowRoot && hasFields(node.shadowRoot)) return true;
     if (node.querySelector('input:not([type="hidden"]),select,textarea')) return true;
     return Array.from(node.querySelectorAll('*')).some(el => el.shadowRoot && hasFields(el.shadowRoot));
    };
    if (hasFields(root)) {this.querySelector('[data-form-fallback]').hidden=true;clearInterval(this.timer);return;}
    if (Date.now()-this.started > 12000) {
     this.querySelector('[data-form-loading]').hidden=true;
     this.querySelector('[data-form-failure]').hidden=false;
    }
    if (Date.now()-this.started > 60000) clearInterval(this.timer);
   };
   this.timer=setInterval(this.check,1000);this.check();
  }
  disconnectedCallback() {clearInterval(this.timer);}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["riven-drop-experience"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('riven-drop-experience')) {
    customElements.define('riven-drop-experience', class extends HTMLElement {
      connectedCallback() {
        this.clock = this.querySelector('.riven-clock');
        this.onScroll = this.updateScroll.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.updateScroll();
        this.updateClock();
        this.onBuy = this.addToCart.bind(this);
        this.addEventListener('submit', this.onBuy);
        if (this.clock) this.timer = window.setInterval(() => this.updateClock(), 1000);
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.clearInterval(this.timer);
        this.removeEventListener('submit', this.onBuy);
      }
      async addToCart(event) {
        const form = event.target;
        if (!form.matches('.riven-buy')) return;
        event.preventDefault();
        const button = form.querySelector('button[type="submit"]');
        if (button.disabled) return;
        const error = form.querySelector('.riven-buy__error');
        error.hidden = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(form.action + '.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || String(response.status));
          window.location.assign(form.elements.return_to.value);
        } catch (failure) {
          error.textContent = failure.message;
          error.hidden = false;
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      }
      updateScroll() {
        const rect = this.getBoundingClientRect();
        const max = Math.max(this.offsetHeight - window.innerHeight, 1);
        const progress = Math.min(Math.max(-rect.top / max, 0), 1);
        this.style.setProperty('--riven-progress', progress.toFixed(4));
      }
      updateClock() {
        if (!this.clock || !this.dataset.launch) return;
        const target = new Date(this.dataset.launch).getTime();
        if (Number.isNaN(target)) return;
        const remaining = Math.max(0, target - Date.now());
        const values = {
          days: Math.floor(remaining / 86400000),
          hours: Math.floor(remaining % 86400000 / 3600000),
          minutes: Math.floor(remaining % 3600000 / 60000),
          seconds: Math.floor(remaining % 60000 / 1000)
        };
        Object.entries(values).forEach(([key, value]) => {
          const field = this.clock.querySelector(`[data-${key}]`);
          if (field) field.textContent = String(value).padStart(2, '0');
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["riven-registration-info"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('riven-piece-context')) {
  customElements.define('riven-piece-context', class extends HTMLElement {
    connectedCallback() {
      const pieces = {'riven-line-apex-1000-tee-concept':'Apex 1000 Tee','riven-line-telemetry-bone-tee-concept':'Telemetry Bone Tee','riven-line-eastern-run-tee-concept':'Eastern Run Tee','riven-line-blackline-heavy-hoodie-concept':'Blackline Heavy Hoodie'};
      const name = pieces[new URLSearchParams(window.location.search).get('piece')];
      if (name) {this.querySelector('[data-piece-name]').textContent = name;this.hidden = false;}
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
